import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './shared/header/header.component';
import { FooterComponent } from './shared/footer/footer.component';
import { AuthService } from './services/auth.service';
import { ThemeService } from './services/theme.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, FooterComponent],
  template: `
    <div class="flex flex-col h-screen bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 transition-colors">
      <app-header />
      <main class="flex-1 overflow-auto pb-12">
        <router-outlet />
      </main>
      <app-footer />
    </div>
  `
})
export class App {
  private authService = inject(AuthService);
  private themeService = inject(ThemeService); // Initialize theme on app start
}
